import * as Types from '../../../gql/base-types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';

// =============================================================================
// Auto-generated by GraphQL Codegen - DO NOT EDIT
// Change the .gql source (or the schema) and re-run: pnpm codegen
// =============================================================================

const defaultOptions = {} as const;
export type UpdateCustomerBillingInfoMutationVariables = Types.Exact<{
  customerId: Types.Scalars['bigint']['input'];
  autoPay: Types.Scalars['Boolean']['input'];
}>;


export type UpdateCustomerBillingInfoMutation = { __typename?: 'mutation_root', update_customers?: { __typename?: 'customers_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'customers', id: number, name?: string | null, billing_frequency: string, auto_pay: boolean }> } | null };


export const UpdateCustomerBillingInfoDocument = gql`
    mutation updateCustomerBillingInfo($customerId: bigint!, $autoPay: Boolean!) {
  update_customers(
    where: {id: {_eq: $customerId}, active: {_eq: "1"}}
    _set: {auto_pay: $autoPay}
  ) {
    affected_rows
    returning {
      id
      name
      billing_frequency
      auto_pay
    }
  }
}
    `;
export type UpdateCustomerBillingInfoMutationFn = Apollo.MutationFunction<UpdateCustomerBillingInfoMutation, UpdateCustomerBillingInfoMutationVariables>;

/**
 * __useUpdateCustomerBillingInfoMutation__
 *
 * To run a mutation, you first call `useUpdateCustomerBillingInfoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCustomerBillingInfoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCustomerBillingInfoMutation, { data, loading, error }] = useUpdateCustomerBillingInfoMutation({
 *   variables: {
 *      customerId: // value for 'customerId'
 *      autoPay: // value for 'autoPay'
 *   },
 * });
 */
export function useUpdateCustomerBillingInfoMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCustomerBillingInfoMutation, UpdateCustomerBillingInfoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCustomerBillingInfoMutation, UpdateCustomerBillingInfoMutationVariables>(UpdateCustomerBillingInfoDocument, options);
      }
export type UpdateCustomerBillingInfoMutationHookResult = ReturnType<typeof useUpdateCustomerBillingInfoMutation>;
export type UpdateCustomerBillingInfoMutationResult = Apollo.MutationResult<UpdateCustomerBillingInfoMutation>;
export type UpdateCustomerBillingInfoMutationOptions = Apollo.BaseMutationOptions<UpdateCustomerBillingInfoMutation, UpdateCustomerBillingInfoMutationVariables>;
import { resolveExecutor, type GqlExecutor, type GqlRequestOptions } from '@hopdrive/sdk-core'


/**
 * @source {@link src/features/billing/queries/updateCustomerBillingInfo.mutation.gql}
 */
export async function updateCustomerBillingInfo(
  variables: UpdateCustomerBillingInfoMutationVariables,
  options?: { executor?: GqlExecutor; raw?: false } & GqlRequestOptions
): Promise<UpdateCustomerBillingInfoMutation['update_customers']>
export async function updateCustomerBillingInfo(
  variables: UpdateCustomerBillingInfoMutationVariables,
  options?: { executor?: GqlExecutor; raw: true } & GqlRequestOptions
): Promise<UpdateCustomerBillingInfoMutation>
export async function updateCustomerBillingInfo(
  variables: UpdateCustomerBillingInfoMutationVariables,
  options?: { executor?: GqlExecutor; raw?: boolean } & GqlRequestOptions
): Promise<UpdateCustomerBillingInfoMutation['update_customers'] | UpdateCustomerBillingInfoMutation> {
  const { executor, raw, ...requestOptions } = options ?? {}
  const result = await resolveExecutor(executor).mutate<UpdateCustomerBillingInfoMutation>(
    UpdateCustomerBillingInfoDocument,
    variables,
    requestOptions
  )
  if (raw) return result
  return result.update_customers
}